export default __webpack_public_path__ + "static/media/Hindi_df_2.747b3f90.mp3";